import React from 'react';
import { ArrowUpRight } from 'lucide-react';
export function CaseStudiesSection() {
  const caseStudies = [{
    tag: 'Landing Page + Email Sequence',
    tagColor: 'bg-blue-100 text-blue-700',
    title: 'SaaS Founder - Launch Landing Page',
    before: 'Landing page at 2.1% opt-in rate. Paid traffic not converting. $0 revenue in launch week.',
    after: 'Rewrote headline, value prop, and CTA flow. Opt-in rate hit 9.4%. $31K in launch week.',
    metric: '+347% Opt-ins'
  }, {
    tag: 'Ad Copy',
    tagColor: 'bg-purple-100 text-purple-700',
    title: 'E-commerce Brand - Facebook Ad Overhaul',
    before: 'ROAS of 1.2x. Ads getting clicks but no purchases. $8K/month ad spend going nowhere.',
    after: 'Rewrote hooks, body copy, and CTAs across 6 ad sets. ROAS climbed to 4.1x. Same budget.',
    metric: '4.1x ROAS'
  }, {
    tag: 'Email Copy Strategy',
    tagColor: 'bg-emerald-100 text-emerald-700',
    title: 'Course Creator - Email Nurture Sequence',
    before: '12K subscribers, 18% open rate, 0.3% click rate. List not converting to buyers.',
    after: 'Rebuilt 7-email sequence with story-driven angles and clear CTAs. 41% open rate, 3.2% click rate.',
    metric: '+$52K Revenue'
  }];
  return <section id="results" className="py-24 bg-slate-50" data-id="element-17" data-mp="2irg0reb3ydj">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18" data-mp="3tq3ngepe0xg9">
        <div className="text-center mb-16" data-id="element-19" data-mp="3tnhgag6esjyk">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-20" data-mp="3pnqt0mg3clys">
            What Happens When Copy Gets Serious
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-21" data-mp="3kr05je1yio3c">
          {caseStudies.slice(0, 2).map((cs, index) => <div key={index} className="bg-white rounded-xl border border-slate-100 p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-22" data-mp="1ixivk3qctb5f" data-mpi={index}>
              <div className="mb-6" data-id="element-23" data-mp="38e4t8kd39zvo">
                <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-4 ${cs.tagColor}`} data-id="element-24" data-mp="38d3h0ckc77cd">
                  {cs.tag}
                </span>
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-25" data-mp="2yi1mf17ald2e">
                  {cs.title}
                </h3>
                <div className="space-y-3" data-id="element-26" data-mp="33d8ne196g3nm">
                  <div className="bg-red-50 border border-red-100 rounded-lg p-4" data-id="element-27" data-mp="3r4w8g2jrckhz">
                    <p className="text-xs font-semibold text-red-500 mb-1" data-id="element-28" data-mp="3w4sc20ojm9x0">
                      Before
                    </p>
                    <p className="text-sm text-slate-700" data-id="element-29" data-mp="3h66ng0wkejxi">{cs.before}</p>
                  </div>
                  <div className="flex justify-center" data-id="element-30" data-mp="3m51dnnwv3arn">
                    <div className="w-5 h-5 rounded-full border-2 border-slate-300 flex items-center justify-center" data-id="element-31" data-mp="25rt4nago4uoc">
                      <div className="w-2 h-2 rounded-full bg-slate-300" data-id="element-32" data-mp="2arfjfoc5aiz9"></div>
                    </div>
                  </div>
                  <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-4" data-id="element-33" data-mp="srzmud6b1qwm">
                    <p className="text-xs font-semibold text-emerald-600 mb-1" data-id="element-34" data-mp="nt4y6ulnp84l">
                      After
                    </p>
                    <p className="text-sm text-slate-700" data-id="element-35" data-mp="11rv511ya2m65">{cs.after}</p>
                  </div>
                </div>
              </div>
              <div className="mt-auto pt-6 flex justify-between items-center" data-id="element-36" data-mp="a2jkdkb27odk">
                <span className="text-2xl font-bold text-emerald-600" data-id="element-37" data-mp="a0f6qanczb03">
                  {cs.metric}
                </span>
                <ArrowUpRight className="w-5 h-5 text-slate-400" data-id="element-38" data-mp="ivmx1qdvrx75" />
              </div>
            </div>)}
        </div>

        {/* Third card centered */}
        <div className="flex justify-center" data-id="element-39" data-mp="e2abjp4i06im">
          <div className="bg-white rounded-xl border border-slate-100 p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col w-full md:w-1/2" data-id="element-40" data-mp="3mjerxsp5m5li">
            <div className="mb-6" data-id="element-41" data-mp="3v83uumnsz9ti">
              <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-4 ${caseStudies[2].tagColor}`} data-id="element-42" data-mp="3v957uwodq6dv">
                {caseStudies[2].tag}
              </span>
              <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-43" data-mp="8zb2qgwt8oa6">
                {'Course Creator - Email Nurture Sequence'}
              </h3>
              <div className="space-y-3" data-id="element-44" data-mp="iqyoc16orb3q">
                <div className="bg-red-50 border border-red-100 rounded-lg p-4" data-id="element-45" data-mp="ipvx1s5gb6na">
                  <p className="text-xs font-semibold text-red-500 mb-1" data-id="element-46" data-mp="mqzg0nispisq">
                    Before
                  </p>
                  <p className="text-sm text-slate-700" data-id="element-47" data-mp="rrwuap0opsoy">
                    {caseStudies[2].before}
                  </p>
                </div>
                <div className="flex justify-center" data-id="element-48" data-mp="2tiqfpsxct44v">
                  <div className="w-5 h-5 rounded-full border-2 border-slate-300 flex items-center justify-center" data-id="element-49" data-mp="2tkbanjnkyp39">
                    <div className="w-2 h-2 rounded-full bg-slate-300" data-id="element-50" data-mp="2yjegh6bdwzca"></div>
                  </div>
                </div>
                <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-4" data-id="element-51" data-mp="2m7luaic0m9jh">
                  <p className="text-xs font-semibold text-emerald-600 mb-1" data-id="element-52" data-mp="2h88vr0bs7e12">
                    After
                  </p>
                  <p className="text-sm text-slate-700" data-id="element-53" data-mp="2c9xliohkr1ib">
                    {'Rebuilt 7-email sequence with story angles and clear CTAs. 41% open rate, 3.2% click rate.'}
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-auto pt-6 flex justify-between items-center" data-id="element-54" data-mp="2zy7ce4tnafgb">
              <span className="text-2xl font-bold text-emerald-600" data-id="element-55" data-mp="2uznq23b531nf">
                {caseStudies[2].metric}
              </span>
              <ArrowUpRight className="w-5 h-5 text-slate-400" data-id="element-56" data-mp="1ojtsfb20ik5k" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}